// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3luSc","savePackageButton":"ClientWallet_savePackageButton__1LECn"};